import type { CurrentRead } from '@signalvote/data';
import { AlertCircle } from 'lucide-react';

/** A settings list that has not loaded looks like an empty one, so the gap is named. */
export function CalendarSettingsReadNotice({
  read,
  subject,
}: {
  read: CurrentRead<unknown>;
  subject: 'calendar connections' | 'calendars' | 'your other campaigns';
}) {
  if (read.status !== 'failed' && read.status !== 'offline') return null;
  return (
    <div role="alert" className="flex items-center gap-2 rounded-md border border-destructive/30 bg-destructive/5 px-3 py-2 text-sm text-destructive">
      <AlertCircle className="h-4 w-4 shrink-0" aria-hidden />
      {read.status === 'offline'
        ? `You're offline, so ${subject} can't load. They show when you reconnect.`
        : `Couldn't load ${subject}. Try again shortly.`}
    </div>
  );
}
